import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { isoStringToObject } from '~/modules/common/dates/convert';
import {
  getEffectiveDateObject,
  compareDateObjects,
  dateAfterMinRepliconDate
} from '~/modules/common/dates/compare';
import { NoValue } from '~/modules/common/components';
import { ResourceRoleSchedule } from '~/modules/common/components/entities/role';
import { RoleScheduleWithTooltip } from '~/modules/common/components/User';

export const RoleColumn = ({ record: resourceList, column }) => {
  const { isRmp2025Q4Enhancements = false } = column || {};

  const roleDates = (resourceList.effectiveRoles || []).map(
    role => role && isoStringToObject(role.effectiveDate)
  );
  const roleScheduleAsOfDate = resourceList.roleSchedulesAsOfDate;

  const roles = resourceList.effectiveRoles || [];

  const effectiveDate =
    roleDates.length > 0 && getEffectiveDateObject(roleDates);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const effectiveSchedule = useMemo(
    () => ({
      effectiveDate: dateAfterMinRepliconDate(effectiveDate) && effectiveDate,
      projectRoles: effectiveDate
        ? (roles || []).filter(
            r =>
              r &&
              r.effectiveDate &&
              compareDateObjects(
                isoStringToObject(r.effectiveDate),
                effectiveDate
              ) === 0
          )
        : roles
    }),
    [effectiveDate, roles]
  );

  const showRoleSchedule = isRmp2025Q4Enhancements
    ? roleScheduleAsOfDate?.effectiveRoleSchedule
    : roles.length > 0;

  return showRoleSchedule ? (
    isRmp2025Q4Enhancements ? (
      <RoleScheduleWithTooltip
        roleScheduleAsOfDate={roleScheduleAsOfDate.effectiveRoleSchedule}
        isRmp2025Q4Enhancements={isRmp2025Q4Enhancements}
        showEffectiveDate
      />
    ) : (
      <ResourceRoleSchedule
        effectiveSchedule={effectiveSchedule}
        showTooltip
        showEffectiveDate
        isRmp2025Q4Enhancements={isRmp2025Q4Enhancements}
      />
    )
  ) : (
    <NoValue />
  );
};

RoleColumn.propTypes = {
  record: PropTypes.object.isRequired,
  column: PropTypes.object
};

export default RoleColumn;
